import {Table} from 'react-bootstrap-v5'
import {CardHeader} from '../../../../../modules/components'
import parseMoney from '../../../../../modules/utils/parseMoney'
import {ClinicInvoiceDoctorModel} from '../models'

interface Props {
    invoiceDoctors: ClinicInvoiceDoctorModel[]
    isExport?: boolean
}
export default function ClinicDoctorInvoiceSubpage({invoiceDoctors, isExport = false}: Props) {
    return (
        <div className='card'>
            <CardHeader title='Profissionais' goBack={!isExport} />
            <div className='card-body p-5'>
                <Table
                    responsive
                    bordered
                    className='table table-hover table-row-dashed table-col-dashed align-middle table-rounded'
                    width='100%'
                >
                    <thead>
                        <tr className='fw-bolder text-muted bg-light'>
                            <th>Profissional</th>
                            <th className='text-center'>Documento</th>
                            <th className='text-center'>Nº conselho</th>
                            <th className='text-center'>Valor</th>
                        </tr>
                    </thead>
                    <tbody>
                        {invoiceDoctors.length > 0 ? (
                            invoiceDoctors.map((invoiceDoctor) => (
                                <tr key={invoiceDoctor.id}>
                                    <td>{invoiceDoctor.nm_doctor}</td>
                                    <td className='text-center'>
                                        {invoiceDoctor.ds_cpf ?? invoiceDoctor.ds_document ?? '-'}
                                    </td>
                                    <td className='text-center'>{invoiceDoctor.ds_crm ?? '-'}</td>
                                    <td className='text-center'>
                                        <span className='fw-bolder'>
                                            {parseMoney(invoiceDoctor.vn_doctor.toFixed(2))}
                                        </span>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td className='text-center' colSpan={4}>
                                    Nenhum profissional com registro de informações
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    )
}
